export const rem = (px: number, base = 16) => {
  const value = px / base;
  return `${value}rem`;
};

export const em = (px: number, base = 16) => {
  const value = px / base;
  return `${value}em`;
};
